import { CLASSIFICATION_TYPE, PAGE_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import {
  CollectionProperties,
  EventData,
  ProductProperties,
  EventPayload,
} from "../../types";

export interface CDPViewedPageEventPayload extends EventPayload {
  products: ProductProperties[];
  collections: CollectionProperties;
}

const CDPViewedAnalyticsEvent: EventData = {
  pageDetail: "",
  pageType: PAGE_TYPE.cdp,
  eventName: "CDP Viewed",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createCDPViewedPageEventPayload =
  eventPagePayloadCreator<CDPViewedPageEventPayload>(CDPViewedAnalyticsEvent);
